export const translations = {
  ko: {
    // Navbar
    'nav.about': 'About',
    'nav.skills': 'Skills',
    'nav.experience': 'Experience',
    'nav.activities': 'Activities',
    'nav.projects': 'Projects',
    'nav.awards': 'Awards',
    'nav.contact': 'Contact',
    
    // Hero
    'hero.motto': '안되면 될 때까지',
    'hero.title': '몰입하는 풀스택 개발자',
    'hero.name': '임현우',
    'hero.description': '안정적이고 확장 가능한 백엔드 시스템과 사용자 친화적인 프론트엔드를 설계하고 구현합니다.',
    'hero.description2': '성능 최적화와 사용자 경험 개선에 집중합니다.',
    'hero.saveAsPDF': 'PDF로 저장',
    
    // About
    'about.title': 'About',
    'about.subtitle': '소개',
    'about.greeting': '안녕하세요. 풀스택 개발자',
    'about.name': '임현우',
    'about.description1': '(주)엔에스원소프트에서 다양한 공공기관 및 인프라 프로젝트를 담당하며, 실시간 모니터링 시스템과 고도화 프로젝트를 리드해왔습니다. 백엔드와 프론트엔드 모두를 다루며, 전체적인 시스템 아키텍처를 설계하고 구현합니다.',
    'about.description2': '문제 해결에 몰입하며, 성능 최적화와 안정적인 시스템 구축에 집중합니다. 새로운 기술을 학습하고 적용하는 것을 즐기며, 지속적인 성장을 추구합니다.',
    
    // Skills
    'skills.title': 'Skills',
    'skills.subtitle': '주요 기술 스택',
    'skills.backend': 'Backend',
    'skills.frontend': 'Frontend',
    'skills.cloud': 'Cloud',
    'skills.database': 'Database',
    'skills.devops': 'DevOps/Tools',
    
    // Experience
    'experience.title': 'Experience',
    'experience.subtitle': '현업 경력',
    'experience.type.regular': '정규직',
    'experience.type.freelance': '외주',
    'experience.type.intern': '인턴',
    
    // Activities
    'activities.title': 'Activities',
    'activities.subtitle': '동아리 및 학회 활동',
    'activities.type.club': '동아리',
    'activities.type.society': '학회',
    'activities.type.startup': '스타트업',
    
    // Projects
    'projects.title': 'Projects',
    'projects.subtitle': '사이드 프로젝트 및 동아리 활동',
    'projects.clickToView': '클릭하여 자세히 보기 →',
    
    // Awards
    'awards.title': 'Awards',
    'awards.subtitle': '수상 내역',
    
    // Contact
    'contact.title': 'Contact',
    'contact.subtitle': '연락처',
    'contact.email': 'Email',
    'contact.phone': 'Phone',
    'contact.linkedin': 'LinkedIn',
    'contact.github': 'GitHub',
    
    // Footer
    'footer.copyright': '© 2026 임현우. All rights reserved.',
  },
  en: {
    // Navbar
    'nav.about': 'About',
    'nav.skills': 'Skills',
    'nav.experience': 'Experience',
    'nav.activities': 'Activities',
    'nav.projects': 'Projects',
    'nav.awards': 'Awards',
    'nav.contact': 'Contact',
    
    // Hero
    'hero.motto': 'Until it works',
    'hero.title': 'Immersive Full-Stack Developer',
    'hero.name': 'Hyunwoo Lim',
    'hero.description': 'I design and implement stable, scalable backend systems and user-friendly frontends.',
    'hero.description2': 'I focus on performance optimization and user experience improvement.',
    'hero.saveAsPDF': 'Save as PDF',
    
    // About
    'about.title': 'About',
    'about.subtitle': 'Introduction',
    'about.greeting': 'Hello. I am a full-stack developer',
    'about.name': 'Hyunwoo Lim',
    'about.description1': 'At NS1 Software, I have led various public institution and infrastructure projects, including real-time monitoring systems and enhancement projects. I handle both backend and frontend, designing and implementing overall system architecture.',
    'about.description2': 'With the belief "Until it works", I immerse myself in problem-solving, focusing on performance optimization and building stable systems. I enjoy learning and applying new technologies, pursuing continuous growth.',
    
    // Skills
    'skills.title': 'Skills',
    'skills.subtitle': 'Key Technology Stack',
    'skills.backend': 'Backend',
    'skills.frontend': 'Frontend',
    'skills.cloud': 'Cloud',
    'skills.database': 'Database',
    'skills.devops': 'DevOps/Tools',
    
    // Experience
    'experience.title': 'Experience',
    'experience.subtitle': 'Professional Experience',
    'experience.type.regular': 'Full-time',
    'experience.type.freelance': 'Freelance',
    'experience.type.intern': 'Intern',
    
    // Activities
    'activities.title': 'Activities',
    'activities.subtitle': 'Club and Society Activities',
    'activities.type.club': 'Club',
    'activities.type.society': 'Society',
    'activities.type.startup': 'Startup',
    
    // Projects
    'projects.title': 'Projects',
    'projects.subtitle': 'Side Projects and Club Activities',
    'projects.clickToView': 'Click to view details →',
    
    // Awards
    'awards.title': 'Awards',
    'awards.subtitle': 'Awards',
    
    // Contact
    'contact.title': 'Contact',
    'contact.subtitle': 'Contact Information',
    'contact.email': 'Email',
    'contact.phone': 'Phone',
    'contact.linkedin': 'LinkedIn',
    'contact.github': 'GitHub',
    
    // Footer
    'footer.copyright': '© 2026 Hyunwoo Lim. All rights reserved.',
  }
};
